"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverColumnFullWidthProps = exports.DriverColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.DriverColumnProps = [
    {
        show: true,
        field: 'contractor',
        title: 'Contractor',
        width: '405px',
        filter: 'text'
    },
    {
        show: true,
        field: 'driver',
        title: 'Driver Name',
        width: '405px',
        filter: 'text'
    },
    {
        show: true,
        field: 'emp_no',
        title: 'Employee No',
        width: '300px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.DriverColumnFullWidthProps = [
    ...exports.DriverColumnProps
];
exports.DriverColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
exports.DriverColumnFullWidthProps[1] = {
    show: true,
    field: 'driver',
    title: 'Driver Name',
    width: 'auto',
    filter: 'text'
};
